import { Injectable, Injector } from '@angular/core';
import { BaseGuard } from '@core/ngrx';
import { createSelector, Store } from '@ngrx/store';

import { isAddressLoading } from '../address/address.selectors';
import { isConsumptionLoading } from '../consumption';
import { getOfferAction } from '../flow/flow.actions';

export const isLoading = createSelector(
  isAddressLoading,
  isConsumptionLoading,
  (loadingAddress, loadingConsumption) => loadingAddress || loadingConsumption
);

@Injectable({ providedIn: 'root' })
export class RetentionOfferGuard extends BaseGuard {
  protected isStateLoading() {
    return this.store$.select(isLoading);
  }

  protected getDispatchActions() {
    return [getOfferAction()];
  }

  constructor(
    protected override readonly injector: Injector,
    protected readonly store$: Store<any>
  ) {
    super(injector);
  }
}
